<template>
  <div class="customer__header header-navi" :class="{ editing, 'image-memo-version': isImageMemoVersion }">
    <template v-if="editing">
      <Button small @click="onCancel">キャンセル</Button>
      <Button :primary="isSP" small @click="onSave">{{ id ? '保存' : '新規登録' }}</Button>
    </template>
    <template v-else>
      <ul class="edit-menu">
        <li>
          <Button class="menu" flat :disabled="buttonDisabled" @click="onDelete">
            <DeleteIcon class="icon" />
            <span>削除</span>
          </Button>
        </li>
        <li v-if="isSP || isImageMemoVersion">
          <Button class="menu" flat :disabled="!id || maintenance || busy" @click="showUploader">
            <CameraIcon class="icon" />
            <span>画像</span>
            <ResizeImageInput class="image-uploader" @resized="onImageUpload" />
          </Button>
        </li>
        <li>
          <Button class="menu" flat :disabled="buttonDisabled" @click="onIntegrate">
            <CombineIcon class="icon" />
            <span>統合</span>
          </Button>
        </li>
        <li>
          <Button class="menu" flat :disabled="isFromCustomer || !id || maintenance" @click="onEdit">
            <editIcon class="icon" />
            <span>編集</span>
          </Button>
        </li>
      </ul>
      <ul class="new-reservation">
        <li>
          <Button class="menu reservation" flat :disabled="buttonDisabled" @click="toReserve">
            <CalendarIcon clock blank class="icon" />
            <span>新規予約</span>
          </Button>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { getAppVersion } from '@/utils/device'
import Button from '@/components/atoms/Button'
import CameraIcon from '@/components/icons/camera'
import CalendarIcon from '@/components/icons/CalendarIcon'
import CombineIcon from '@/components/icons/combine'
import DeleteIcon from '@/components/icons/delete'
import EditIcon from '@/components/icons/edit'
import ResizeImageInput from '@/components/molecules/ResizeImageInput'

export default {
  name: 'CustomerDetailNavi',
  components: {
    Button,
    CameraIcon,
    CalendarIcon,
    CombineIcon,
    DeleteIcon,
    EditIcon,
    ResizeImageInput,
  },
  props: {
    id: { type: Number },
    editing: { type: Boolean, default: false },
    onlyEdit: { type: Boolean, default: false },
    isSP: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
    maintenance: { type: Boolean, default: false },
  },
  computed: {
    buttonDisabled() {
      return !this.id || this.onlyEdit || this.maintenance
    },
    isFromCustomer() {
      return document.referrer.includes('customer/init')
    },
    isImageMemoVersion() {
      return getAppVersion() >= '1.3.5'
    },
  },
  methods: {
    onEdit() {
      this.$emit('edit')
    },
    onDelete() {
      this.$emit('delete')
    },
    onIntegrate() {
      this.$emit('integrate')
    },
    async onImageUpload({ blob }) {
      if (await this.$store.dispatch('imageMemos/regist', { customerId: this.id, blob })) {
        this.$emit('imageUploaded')
      }
    },
    toReserve() {
      if (this.isSP) {
        this.$router.push({ name: 'ReserveNew', query: { customer_id: this.id } })
      } else {
        location.assign(`/reservation/edit/init?customer_id=${this.id}`)
      }
    },
    showUploader() {
      this.$el.querySelector('.image-uploader').click()
    },
    onSave() {
      this.$emit('save')
    },
    onCancel() {
      this.$emit('cancel')
    },
  },
}
</script>

<style lang="postcss" scoped>
.customer__header {
  align-items: center;
  background-color: var(--very-light-gray-2);
  border-bottom: 1px solid var(--border-color);
  box-sizing: border-box;
  display: flex;
  height: 56px;
  justify-content: flex-end;
  padding-right: 12px;

  &.editing {
    display: grid;
    grid-auto-flow: column;
    grid-gap: 16px;
  }

  .edit-menu {
    display: flex;
  }

  li {
    margin-left: 16px;
  }

  .responsive & {
    @media screen and (--sp-modal) {
      justify-content: initial;
      padding: 8px 24px;

      li {
        margin-left: 0;
      }

      .edit-menu {
        flex-grow: 1;
        justify-content: space-between;
        padding-right: 24px;
      }

      .new-reservation {
        border-left: 1px solid var(--dark-gray);
        padding-left: 24px;
      }
    }
  }

  .responsive &.image-memo-version {
    .edit-menu {
      padding-right: 16px;
    }

    .new-reservation {
      padding-left: 16px;
    }
  }
}

.menu {
  color: var(--very-dark-gray-2);
  font-weight: normal;
  margin: 0 4px;
  padding: 16px 0;

  .responsive & {
    @media screen and (--sp-modal) {
      display: block;
      padding: 0;

      &.flat,
      svg {
        margin: 0;
      }
      span {
        display: block;
        font-size: 12px;
        line-height: 1;
      }
    }
  }
}

.menu:disabled {
  border: none;
  opacity: 0.2;
}

.menu:focus {
  outline: none;
}

.menu.reservation > svg {
  border-left: 1px solid var(--dark-gray);
  padding-left: 20px;

  .responsive & {
    @media screen and (--sp-modal) {
      border-left: none;
      padding-left: 0;
    }
  }
}

.icon {
  fill: var(--very-dark-gray-2);
}
</style>
